// extracted by mini-css-extract-plugin
export default {"root":"AlertsBadge_root__Oeb98","critical":"AlertsBadge_critical__qhlt7","warning":"AlertsBadge_warning__bCVwb","success":"AlertsBadge_success__TdMPh"};